import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSignSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#454655"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M2.334 16.1c1.175-.08 2.232-.268 3.365-.695 2.642-.995 5.462-2.433 7.52-4.637.573-.614 1.348-1.763.973-2.754-.28-.742-1.138-1.074-1.79-1.005-2.718.289-3.827 4.08-3.53 6.728.456 4.059 4.84 4.45 7.504 2.98 1.959-1.083 3.332-3.33 4.498-5.352.081-.141.146-.3.254-.414.034-.036.012.108 0 .16-.153.666-.37 1.31-.507 1.983-.175.852-.356 1.858.098 2.65.477.832 1.357 1.253 2.2 1.033 1.026-.268 2.014-1.101 2.748-1.945M4.667 23.334c3.397-.7 6.754-1.099 10.267-1.157 2.468-.04 4.873.013 7.233.617M17.5 5.834c.698-.483 1.46-.858 2.333-1.167"
    />
  </svg>
);
export default SvgSignSide;
